import { LogoComponentData, CmsComponentData } from '@boels/models';
import { of } from 'rxjs';

export const logoRotatorDataMock: LogoComponentData = {
  uid: 'cmsitem_00176000',
  typeCode: 'LogoRotatorComponent',
  modifiedTime: new Date('2022-06-15T13:51:23.004+02:00'),
  name: 'Logo',
  title: 'Our partners',
  logos: {
    demoLogoFly: {
      code: 'demoLogoFly',
      mime: 'image/png',
      altText: 'demoLogoFly.png',
      url: '/medias/demoLogoFly.png?context=bWFzdGVyfHJvb3R8MTc4ODJ8aW1hZ2UvcG5nfGhjNS9oMTUvOTUxMzQ1MTIyNTExOC9kZW1vTG9nb0ZseS5wbmd8OTg2YjJmMDMzMDAwZThjNGVjNjdmOTEwOTdlZDgyNWU5NmQ0M2Q5NjMzMTEzMTRkZmMwNmU4YWY2ZTFiOTU0Yg',
    },
    demoLogoFmf: {
      code: 'demoLogoFmf',
      mime: 'image/png',
      altText: 'demoLogoFmf.png',
      url: '/medias/demoLogoFmf.png?context=bWFzdGVyfHJvb3R8MjA1NjJ8aW1hZ2UvcG5nfGhkNi9oMTgvOTUxMzQ1MTE1OTU4Mi9kZW1vTG9nb0ZtZi5wbmd8Y2Q0ZjgxNTNjNjcwYWM0OWE0NjRmYzUyYTdiYmUwY2NlOGJlZTVmZGFkMjlhZGRjODY0ZWM1MmFhMTNjNzMxYw',
    },
    demoLogoFox: {
      code: 'demoLogoFox',
      mime: 'image/png',
      altText: 'demoLogoFox.png',
      url: '/medias/demoLogoFox.png?context=bWFzdGVyfHJvb3R8MTA1MjV8aW1hZ2UvcG5nfGg2Yy9oMTgvOTUxMzQ1MTE5MjM1MC9kZW1vTG9nb0ZveC5wbmd8YzcyM2IwNGQ3ZjRmMTRmNzBkNTlhMzY4NmRmMzJkNTRjMzVlMThhYzA4YWY2YjNiNjI5ZWI4ZjhhODllYWIyYg',
    },
    demoLogoGaerne: {
      code: 'demoLogoGaerne',
      mime: 'image/png',
      altText: 'demoLogoGaerne.png',
      url: '/medias/demoLogoGaerne.png?context=bWFzdGVyfHJvb3R8MTkxOTh8aW1hZ2UvcG5nfGhhZi9oMTEvOTUxMzQ1MTM4ODk1OC9kZW1vTG9nb0dhZXJuZS5wbmd8MzM4NjM2NzgxZjM4YmY4ZjRiY2JkODJlNDFlNzhkYTE3OGQxZDg2ODY1NWZhNzgyYzAzZmM4MzM3NmFjMzc0Zg',
    },
    sefs: {
      code: 'sefs',
      mime: 'image/png',
      altText: 'alt',
      url: '/medias/good-test.png?context=bWFzdGVyfHJvb3R8MjA3Mzd8aW1hZ2UvcG5nfGgxZi9oOTIvOTUxNjQ2NjYwMjAxNC9nb29kX3Rlc3QucG5nfDRkM2ZhNjU3MGRjZmYzNzUzMmVhMGU3MDFlMGFjMWVjNjdhNDlkOTkzN2ZhOTM3MTBjNGI0NGEyNTBiNGRhN2Q',
    },
    demoLogoFoxHead: {
      code: 'demoLogoFoxHead',
      mime: 'image/png',
      altText: 'demoLogoFoxHead.png',
      url: '/medias/demoLogoFoxHead.png?context=bWFzdGVyfHJvb3R8MTAwNzF8aW1hZ2UvcG5nfGg1ZC9oMTIvOTUxMzQ1MTMyMzQyMi9kZW1vTG9nb0ZveEhlYWQucG5nfDVkZGJhM2RlYzE4ODRiNjk4YmViMGJlN2U5Mzk0YTU2MzZiZmU4YTNiMzFiNzU5ODBlMWEzOTk4YjcyNzgyOWY',
    },
    demoLogoFastHouse: {
      code: 'demoLogoFastHouse',
      mime: 'image/png',
      altText: 'demoLogoFastHouse.png',
      url: '/medias/demoLogoFastHouse.png?context=bWFzdGVyfHJvb3R8MTA1MTV8aW1hZ2UvcG5nfGgyZC9oMTkvOTUxMzQ1MTEyNjgxNC9kZW1vTG9nb0Zhc3RIb3VzZS5wbmd8OWRiNjU3MjliOWQzYmVkNTA3ZDgzMDZiNTU0ODdjYzY1MGY0OGMzYWJkM2U0ZjBiMDkxNGI1MDFkYmEwOGVlYw',
    },
    demoLogoHonda1: {
      code: 'demoLogoHonda1',
      mime: 'image/png',
      altText: 'demoLogoHonda1.png',
      url: '/medias/demoLogoHonda1.png?context=bWFzdGVyfHJvb3R8MTk2NTR8aW1hZ2UvcG5nfGhmNS9oMGUvOTUxMzQ1MTQyMTcyNi9kZW1vTG9nb0hvbmRhMS5wbmd8ZDBkMmY5Mjk4ODY1ZWNlYTU5MzZjNTY2MDE4NmIwZTlhNmI0ZTRlNThmNzFhZGI1YjY2OTNlZDAzOTBkZjc4OA',
    },
  },
};

export const logoRotatorDataMockComponentData: CmsComponentData<LogoComponentData> =
  {
    data$: of(logoRotatorDataMock),
  };
